// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WAF-","type":"styles_type__2uMHH","choices":"styles_choices__3P4DS"};